import { addDoc, arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { db } from "../firebase";
import Invite from "../models/Invite";
import UserController from "./UserController";
import PlanController from "./PlanController";

const getInvites = async (user_id: string): Promise<Invite[]> => {
    const inviteRef = collection(db, "invite");
    const q = query(inviteRef, where("user_id", "==", user_id));
    const inviteSnapshot = await getDocs(q);
    const invites: Invite[] = [];
    inviteSnapshot.forEach((doc) => {
        const invite = doc.data() as Invite;
        invite.uid = doc.id;
        invites.push(invite);
    });
    return invites
}

const getPendingInvites = async (plan_id: string): Promise<Invite[]> => {
    const inviteRef = collection(db, "invite");
    const q = query(inviteRef, where("plan_id", "==", plan_id));
    const inviteSnapshot = await getDocs(q);
    const invites: Invite[] = [];
    inviteSnapshot.forEach((doc) => {
        const invite = doc.data() as Invite;
        invite.uid = doc.id;
        invites.push(invite);
    });
    return invites
}

const createInvite = async (message: string, email: string, plan_id: string): Promise<string> => {
    const user = await UserController.getUserByEmail(email);
    const user_id = user.uid;
    const invite: Partial<Invite> = {
        message,
        user_id,
        email,
        plan_id,
    }
    const docRef = await addDoc(collection(db, "invite"), invite);
    return docRef.id;
}

const acceptInvite = async (invite: Invite) => {
    const inviteRef = doc(db, "invite", invite.uid);
    PlanController.inviteMember(invite.plan_id, invite.user_id);
    await deleteDoc(inviteRef);
}
const declineInvite = async (invite: Invite) => {
    const inviteRef = doc(db, "invite", invite.uid);
    await deleteDoc(inviteRef);
}


const InviteController = {
    getInvites,
    getPendingInvites,
    createInvite,
    acceptInvite,
    declineInvite
}
export default InviteController;